import React, { useState } from "react";
import classes from "./DataEngine.module.css";
import AccountValueChart from "../chart/AccountValueChart";
import CommonButton from "../../ui/CommonButton";
import DataMonetizationTable from "./DataMonetizationTable";

const Card = ({ title, value, className = "", children }) => (
    <div
      className={`${classes.card} ${classes.statsCard} ${className} d-flex flex-column justify-content-between `}
    >
      <h6 className={classes.titleText}>{title}</h6>
      <div className={classes.valueText}>{value || children}</div>
    </div>
);

const listData = [
  {
    title: "You trade",
    desc: "Every action you take is logged and anonymized.",
  },
  {
    title: "We analyze",
    desc: "Our system detects patterns, behaviors, and edge signals across the cohort.",
  },
  {
    title: "We monetize",
    desc: "These insights drive live strategies that generate profits on accounts.",
  },
  {
    title: "You benefit",
    desc: "Data helps refine funding logic, powers future copy trading products, and creates a sustainable ecosystem.",
  },
];

const DataEngine = () => {
  const [activeTab, setActiveTab] = useState("account");
  const stats = [
    { title: "Balance", value: "$50,000" },
    { title: "Equity", value: "$50,000" },
    {
      title: "Gain",
      value: <span className={`${classes.positive}`}>0%</span>,
    },
    {
      title: "Max Drawdown",
      value: <span className={classes.negative}>0%</span>,
    },
  ];

  const accountValueData = [
    { name: "7BK", value: 70 },
    { name: "5BK", value: 50 },
    { name: "2BK", value: 20 },
    { name: "0K", value: 0 },
  ];

  const monthlyGains = {
    year: 2025,
    months: [],
    // months: [
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   <span className={classes.positive}>+1.29%</span>,
    //   <span className={classes.positive}>+2.00%</span>,
    //   <span className={classes.negative}>-1.20%</span>,
    //   <span className={classes.positive}>+1.00%</span>,
    //   <span className={classes.positive}>+1.35%</span>,
    //   <span className={classes.positive}>4.44%</span>,
    // ],
  };

  return (
    <div className={`${classes.wrapper}`}>
      <div className="d-flex align-items-center justify-content-between mb-md-4 mb-3">
        <Card title="Total value locked" value="$100,000" />
        <div className="d-md-flex d-none">
          <CommonButton text="Copy trade (coming soon)" />
        </div>
      </div>

       <div className="d-flex d-md-none mb-3">
          <CommonButton text="Copy trade (coming soon)" className="w-100" />
        </div>

      <DataMonetizationTable />

      <div className={`${classes.card} row mt-4 px-3 mx-0`}>
        <div className="col-md-6 mt-4">
          <h4>How it works</h4>
          <p>
            As traders go through the free 2-step challenge, their trading
            behavior is captured in real-time. This data fuels proprietary
            strategies running on internal accounts (like the ones shown above)
          </p>
          <img
            src="/images/Hamsterwheel.svg"
            alt="man running in a hamsterwheel"
          />
        </div>

         <div className={`col-md-6 ${classes.rightCol}`}>
          <ul>
            {listData.map((item, i) => (
              <li key={i}>
                <span>{item.title}</span>
                <p>{item.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DataEngine;
